import { useState, useEffect } from 'react';
import { getEntitlement } from './FinancialService';
import { EntitlementInfo } from './types';

// Module-level cache — shared across all hook instances for the session.
// Prevents redundant API calls when multiple gated pages are mounted.
let _cached: EntitlementInfo | null = null;
let _pending: Promise<EntitlementInfo | null> | null = null;

export function useEntitlement(): {
  info: EntitlementInfo | null;
  loading: boolean;
  } {
  const [info, setInfo] = useState<EntitlementInfo | null>(_cached);
  const [loading, setLoading] = useState(_cached === null);

  useEffect(() => {
    if (_cached !== null) {
      setInfo(_cached);
      setLoading(false);
      return;
    }
    if (!_pending) {
      _pending = getEntitlement()
        .then((r) => {
          _cached = r.data.entitlement;
          return _cached;
        })
        .catch(() => null)
        .finally(() => {
          _pending = null;
        });
    }
    _pending.then((result) => {
      setInfo(result);
      setLoading(false);
    });
  }, []);

  return { info, loading };
}
